// extracted by mini-css-extract-plugin
export default {"registrationButtonSpacing":"_1D5uv","registrationButtonSpacing--noImage":"_1gq7K","registrationButtonSpacingNoImage":"_1gq7K","secondaryButtonSpacing":"_2mZJl"};